import React from 'react';
import {
  Box,
  Button,
  ButtonProps,
  Grid,
  ModalHeader,
  ModalBody,
} from '@chakra-ui/react';
import Card from 'layouts/Card';
import { FiPlus } from 'react-icons/fi';
import 'theme/components/rcTree.css';
import { PermissionsGate, ModalForm, InfoBadge } from 'components';
import { CAN_EDIT_CAMPAIGNS } from 'consts/permissions';
import { campaignCreatePage } from './Campaign.Links';
import { useTranslation } from 'react-i18next';
import { MonitoringUploadFiles, MonitoringCodesTree } from './Monitoring';
import {
  useGetCampaignCodes,
  //useGetCampaignProposalsOverview,
} from 'queries/monitoring';
import { FieldsetSkeleton } from 'components/Skeletons';

//import 'rc-tree/assets/index.css';

export const CampaignMonitoringCodesModal = ({
  campaignId,
  ...props
}: { campaignId: number } & ButtonProps): JSX.Element | null => {
  const { t } = useTranslation();
  /* const { data: proposalsOverview } = useGetCampaignProposalsOverview(
    campaignId,
  ); */
  //const hasMonitoringProposal = (proposalsOverview?.length ?? 0) > 0;

  //if (!hasMonitoringProposal) return null;

  return (
    <PermissionsGate requiredPermissions={[CAN_EDIT_CAMPAIGNS]}>
      <ModalForm
        trigger={
          <Button
            to={campaignCreatePage()}
            {...props}
            leftIcon={<FiPlus />}
            variant='send'
          >
            {t('monitoring.uploadCodes', 'Dodaj kody')}
          </Button>
        }
        form={<CampaignMonitoringCodes campaignId={campaignId} />}
      />
    </PermissionsGate>
  );
};

export const CampaignMonitoringCodes = ({
  campaignId,
}: {
  campaignId: number;
}): JSX.Element | null => {
  const { t } = useTranslation();
  const { data } = useGetCampaignCodes(campaignId);

  const { available: codesAvailable, assigned: codesAssigned } = data || {};

  if (!codesAssigned || !codesAvailable) return <FieldsetSkeleton />;

  return (
    <>
      <ModalHeader mb={4}>
        {t('monitoring.uploadCodesModalHeader', 'Pula kodów kampanii')}
      </ModalHeader>
      <ModalBody>
        <Box as={Card} p={5} minW={0}>
          <Grid gap={4}>
            <Box>
              <MonitoringUploadFiles campaignId={campaignId} />
            </Box>
            {codesAvailable.length > 0 && (
              <InfoBadge>
                {t(
                  'monitoring.info.unassignedCodes',
                  'Niektóre dodane kody nie są przypisane do produktów.',
                )}
              </InfoBadge>
            )}
            {codesAvailable && (
              <MonitoringCodesTree
                codesNodes={codesAvailable}
                codesType='available'
                campaignId={campaignId}
              />
            )}
            {codesAssigned && (
              <MonitoringCodesTree
                codesNodes={codesAssigned}
                codesType='assigned'
                campaignId={campaignId}
              />
            )}
          </Grid>
        </Box>
      </ModalBody>
    </>
  );
};
